import React from "react";

import { List } from "@refinedev/mui";
import SettingsIcon from "@mui/icons-material/Settings";
import { useNavigate } from "react-router-dom";
import { ITag } from "interfaces/tag";
import { InfiniteList } from "components/list/infinity-list";
import { CardContent, Typography, IconButton } from "@mui/material";

export const TagList: React.FC = () => {
  const navigate = useNavigate();

  return (
    <List
      title="Tags List"
      wrapperProps={{
        style: {
          backgroundColor: "transparent",
          boxShadow: "none",
          padding: 0,
        },
      }}
    >
      <InfiniteList<ITag>
        endpoint="tags"
        limit={5}
        renderItem={(tag) => (
          <CardContent
            sx={{
              pl: 3,
              "&:last-child": { pb: 2 },
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "white",
            }}
          >
            <Typography variant="body1" fontWeight="bold">
              {tag.tagName}
            </Typography>
            <IconButton
              onClick={() => navigate(`/tags/${tag.tagId}/edit`)}
              edge="end"
            >
              <SettingsIcon />
            </IconButton>
          </CardContent>
        )}
        searchConfig={{
          enabled: true,
          placeholder: "Search investments...",
          searchField: "keyword",
        }}
      />
    </List>
  );
};
